import React, { useState } from 'react';
import { FormattedMessage } from '../../../util/reactIntl';

import { Button, Modal } from '../../../components';

import css from './SubmitFinePrint.module.css';

export const getBookingInfoMessageId = listingType =>
  listingType === 'schedule-services'
    ? 'OrderPanel.scheduleServiceBookingInfoText'
    : 'OrderPanel.bookingInfoText';

/**
 * A component that displays the fine print for the submit button.
 * Note: this is not in use for ProductOrderForm.
 *
 * @component
 * @param {Object} props
 * @param {string} [props.payoutDetailsWarning] - The payout details warning
 * @param {boolean} [props.isOwnListing] - Whether the listing is owned by the current user
 */
const SubmitFinePrint = ({
  payoutDetailsWarning,
  isOwnListing,
  omitYouWontBeChargedMessage = false,
  onManageDisableScrolling = () => null,
  listingType,
}) => {
  const [isInfoModalOpen, setInfoModalOpen] = useState(false);

  return (
    <>
      <div className={css.finePrint}>
        {payoutDetailsWarning ? (
          payoutDetailsWarning
        ) : isOwnListing ? (
          <FormattedMessage id="OrderPanel.ownListing" />
        ) : !omitYouWontBeChargedMessage ? (
          <>
            <p className={css.finePrintText}>
              <FormattedMessage id="OrderPanel.youWontBeChargedInfo" />
            </p>
            <button className={css.infoLink} type="button" onClick={() => setInfoModalOpen(true)}>
              <FormattedMessage id="OrderPanel.bookingInfoLink" />
            </button>
          </>
        ) : null}
      </div>
      <Modal
        id="BookingInformationModal"
        isOpen={isInfoModalOpen}
        onClose={() => setInfoModalOpen(false)}
        onManageDisableScrolling={onManageDisableScrolling}
      >
        <p className={css.modalText}>
          <FormattedMessage id={getBookingInfoMessageId(listingType)} />
        </p>
        <Button type="button" onClick={() => setInfoModalOpen(false)}>
          <FormattedMessage id="OrderPanel.bookingInfoClose" />
        </Button>
      </Modal>
    </>
  );
};

export default SubmitFinePrint;
